import React, { useState } from "react";
import faqData from "./faqData";
import checkitout from "../../../images/checkitout.png";

export default function Faq(props) {
    const { id, setSelectedFaq, highPriority=true } = props;
  
    const [opened, setOpened] = useState(false);
  
    return (
      <div className="faq-line" onClick={onClick}>
        <div className="checkitout-wrapper">
          {!opened && highPriority && <img className="checkitout" src={checkitout} />}
        </div>
        <div key={id} className='faq-title'>
          {faqData[id].title}
        </div>
      </div>
    )
  
    function onClick() {
      setOpened(true);
      setSelectedFaq(id);
    }
  }